import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { components } from 'react-select';

/**
 * @param {import('react-select').OptionProps<import('./usePlanPickerApi/items').PlanPickerItemWithStatus>} props
 */
function PlanPickerOption(props) {
    const { className, data, label, isDisabled, isFocused, isSelected } = props;

    const optionWrapperClasses = classNames(
        className,
        'asc-select__option asc-select__option--custom',
        `dca-plan-picker__option dca-plan-picker__option--${data.status}`,
        typeof data.ix !== 'undefined' &&
            `dca-plan-picker__option--${data.ix % 2 === 0 ? 'even' : 'odd'}`,
        data.status === 'loaded' && `dca-plan-picker__option--${data.kind}`,
        {
            'asc-select__option--is-disabled is-disabled': isDisabled,
            'asc-select__option--is-focused': isFocused,
            'asc-select__option--is-selected': isSelected
        }
    );

    return (
        <components.Option {...props} className={optionWrapperClasses}>
            {data.status === 'loaded' ? (
                <div className="dca-plan-picker__option__row-layout">
                    <span className="dca-plan-picker__option__name">{label}</span>
                    <span className="dca-plan-picker__option__money-value">{data.moneyValue}</span>
                </div>
            ) : (
                <div className="asc-skeleton dca-plan-picker__option__skeleton">
                    <span className="visually-hide">{label}</span>
                </div>
            )}
        </components.Option>
    );
}

PlanPickerOption.propTypes = {
    className: PropTypes.string,
    data: PropTypes.object.isRequired,
    innerProps: PropTypes.object,
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    label: PropTypes.string.isRequired
};

export default memo(PlanPickerOption);
